<template>
        <Header></Header>

        <main class="flex-auto bg-white lg:bg-neutral-50">
            <router-view :key="$route.path"></router-view>
        </main>

        <Footer></Footer>
</template>

<script>
import axios from 'axios'
import Header from '@/frontend/components/Header.vue';
import Footer from '@/frontend/components/Footer.vue';

export default {
    components: { Footer, Header },
    mounted() {
        axios.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            console.error(error)
            if (error.response.status === 401 || error.response.status === 419) {
                if (error.response.data.message === 'CSRF token mismatch.') return
                this.logout()
                    .catch((error) => { console.error(error) })
            }

            return Promise.reject(error);
        });
    },
}
</script>
